import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={178}
    height={179}
    viewBox="0 0 178 179"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity={0.1}
      x={0.25}
      y={0.75}
      width={177.5}
      height={177.5}
      rx={88.75}
      fill="#C4C4C4"
    />
    <path
      d="M121.381 50.6432C121.381 47.0683 118.48 44.167 114.905 44.167H63.0953C59.5205 44.167 56.6191 47.0683 56.6191 50.6432V57.1193H121.381V50.6432Z"
      fill="#666666"
    />
    <path
      d="M127.856 63.5959H50.1422C46.5673 63.5959 43.666 66.4973 43.666 70.0721V108.929C43.666 112.504 46.5673 115.405 50.1422 115.405H56.6184V128.358C56.6184 131.932 59.5197 134.834 63.0945 134.834H114.904C118.479 134.834 121.38 131.932 121.38 128.358V115.405H127.856C131.431 115.405 134.332 112.504 134.332 108.929V70.0721C134.332 66.4973 131.431 63.5959 127.856 63.5959ZM114.904 128.358H63.0945V95.9768H114.904V128.358ZM121.38 83.0245H108.428V76.5483H121.38V83.0245Z"
      fill="#666666"
    />
    <path
      d="M69.5703 115.406H88.9988V121.882H69.5703V115.406Z"
      fill="#666666"
    />
    <path
      d="M69.5703 102.452H108.427V108.929H69.5703V102.452Z"
      fill="#666666"
    />
  </svg>
);
export default SVGComponent;
